import '../../../styles/ModalFacturaEmitida.css'
import { useDispatch, useSelector } from 'react-redux'

import {ModalBase} from '../ModalBase'

import Printer from '../../../media/felsv/Printer.svg'
import Email from '../../../media/felsv/Email.svg'
import Download from '../../../media/felsv/Download.svg'
import Folder from '../../../media/felsv/Folder.svg'
import DownloadImage from '../../../media/felsv/DownloadImage.svg'
import DownloadJson from '../../../media/felsv/DownloadJson.svg'
import DeleteFileIcon from '../../../media/felsv/dark_delete_file_icon.svg'

import { setModoTicketPrint, setStatusModalAnular, setStatusModalEnvio, setStatusModalImprimir } from '../../../actions/historial/historial.actions'
import { actionsOperaciones } from '../../../actions/action-creators'
import { bindActionCreators } from 'redux'
import { State } from '../../../reducers'
import { generalOpenModalInfo, generalShowLoader, msgFuncionalidadLimitada, validateHorarioSucursal } from '../../../actions/general.actions'

interface PropsAcciones {
  onCancel: () => void
  factura: any
  qrCode: string
  anulado: boolean
}

const ModalHistorialAcciones = (props: PropsAcciones) => {
  const {qrCode, factura, anulado} = props;
  const {datos, config} = useSelector((state: State) => state.userLogin);
  
  const dispatch = useDispatch();
  const {getExcelFactura, getFacturaPDF_New, getFacturaImage, descargarJson} = bindActionCreators(actionsOperaciones, dispatch);

  const handleExcel = () => {
    getExcelFactura(
      {Documento: factura?.documento, Sello: factura?.sellorecibido}, 
      factura?.DetallesDTE?.identificacion?.numeroControl
    );
  }

  const handlePDF = (modoTicket: boolean = false) => {
    getFacturaPDF_New(
      {Documento: factura?.documento, Sello: factura?.sellorecibido, ModoTicket: modoTicket},
      factura?.DetallesDTE?.identificacion?.numeroControl,
      factura?.estadoanulacion
    );
  }

  const handleImage = () => {
    getFacturaImage(
      {Documento: factura?.documento, Sello: factura?.sellorecibido},
      factura?.DetallesDTE?.identificacion?.numeroControl
    );
  }

  const handleJson = () => descargarJson({idFactura: factura?.DetallesDTE?.identificacion?.codigoGeneracion , json: factura?.JsonFacturaFile})

  const handleAnular = async () => {
    //if (datos?.aspel) {
    //  dispatch(generalOpenModalInfo(msgFuncionalidadLimitada(datos)));
    //  return;
    //}
    if(await dispatch(validateHorarioSucursal('', '/', true, 'anular el documento'))) {
      dispatch(setStatusModalAnular(true))
    } 
  }

  return (
    <ModalBase>
      <div className='modal-card' style={{width: '100%'}}>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>Más opciones</h3>
          </div>
          <div className='form-separator'></div>
          <div className='modal-emitido-div-qr'>
            {
              qrCode && (
                <img
                  src={qrCode}
                  alt='qr'
                  className='modal-emitido-img-qr'
                />
              )
            }
          </div>
          <div
            className='m button-actions'
            style={{margin: '0 auto', width: '100%', textAlign: 'center'}}
          >
            <div className='flex-full-center flex-wrap' style={{alignItems: 'start'}}>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={Printer} alt='Imprimir' onClick={() => dispatch(setStatusModalImprimir(true))} />
                </button>
                <label className='modal-accion-descripcion'>Imprimir</label>
              </div>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={Email} alt='correo electrónico' onClick={() => dispatch(setStatusModalEnvio(true))} />
                </button>
                <label className='modal-accion-descripcion'>Enviar</label>
              </div>
              <div className='vertical-separator-btns'></div>
              <div>
                <button className='modal-emitido-button-icon' onClick={() => handlePDF()}>
                  <img src={Download} alt='Download' />
                </button>
                <label className='modal-accion-descripcion'>Descargar PDF</label>
              </div>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={Folder} alt='Download folder' onClick={handleExcel}/>
                </button>
                <label className='modal-accion-descripcion'>Descargar CSV</label>
              </div>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={DownloadImage} alt='Download 2' onClick={handleImage} />
                </button>
                <label className='modal-accion-descripcion'>Descargar imagen</label>
              </div>       
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={DownloadJson} alt='Download JSON' onClick={handleJson} />
                </button>
                <label className='modal-accion-descripcion'>Descargar json</label>
              </div> 
              {/* <div>
                <button className='modal-emitido-button-icon'>
                  <img src={ReloadFileIcon} alt='Anular factura' />
                </button>
                <label className='modal-accion-descripcion'>Nota de Crédito</label>
              </div> */}
              {
                (
                  !anulado
                ) &&
                (
                  <>
                  <div className='vertical-separator-btns'></div>
                  <div>
                    <button className='modal-emitido-button-icon'>
                      <img src={DeleteFileIcon} alt='Anular factura' onClick={handleAnular} />
                    </button>
                    <label className='modal-accion-descripcion'>Anular</label>
                  </div>
                  </>
                )
              }
            </div>
          </div>
          {config?.tickethabilitado && (
            <>
              <div className='form-separator'></div>
              <label style={{ textAlign: 'center', display: 'block' }}>Opciones Ticket:</label>
              <div className='m button-actions' style={{margin: '0 auto', width: '100%', textAlign: 'center'}}>
                <div className='flex-full-center flex-wrap' style={{alignItems: 'start'}}>
                  <div>
                    <button className='modal-emitido-button-icon'>
                      <img src={Printer} alt='Imprimir ticket' onClick={() => { dispatch(setModoTicketPrint(true)); dispatch(setStatusModalImprimir(true)); }} />
                    </button>
                    <label className='modal-accion-descripcion'>Imprimir ticket</label>
                  </div>
                  <div>
                    <button className='modal-emitido-button-icon' onClick={() => handlePDF(true)}>
                      <img src={Download} alt='Descargar ticket' />
                    </button>
                    <label className='modal-accion-descripcion'>Descargar PDF Ticket</label>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={props.onCancel}>
              <div>Cerrar</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalHistorialAcciones
